export default {
  title: 'Få den bedste oplevelse i vores mobilapp',
  description: 'Spar tid, optjen belønninger, få besked om flere tilbud og meget mere',
  buttons: {
    download: 'Åbn {{name}}-appen',
  },
};
